import React from 'react';
import { motion } from 'framer-motion';
import './AboutPage.css';

const AboutPage = () => {
  const stats = [
    { number: '100', label: 'Dives Logged', icon: '🤿' },
    { number: '11', label: 'Countries Explored', icon: '🌊' },
    { number: '10+', label: 'Years Diving', icon: '📅' },
  ];


  return (
    <div className="about-page">
      {/* Stat tiles */}
      <section className="about-stats-section">
        <div className="container">
          <div className="about-stats-grid">
            {stats.map((stat, i) => (
              <motion.div
                key={stat.label}
                className="about-stat-tile"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                viewport={{ once: true }}
              >
                <span className="about-stat-icon">{stat.icon}</span>
                <span className="about-stat-number">{stat.number}</span>
                <span className="about-stat-label">{stat.label}</span>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Hero section */}
      <section className="about-hero">
        <div className="container">
          <div className="about-hero-content">
            {/* Bio text */}
            <motion.div
              className="about-bio"
              initial={{ opacity: 0, x: -30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.7 }}
            >
              <h1 className="about-title">About Me</h1>
              <p className="about-description">
                Hi, I'm Ross — a passionate scuba diver, currently based in London.
                Through this blog, I share my diving adventures, tips for fellow divers,
                and underwater stories.
              </p>
              <p className="about-description">
                Whether you're a beginner looking to get started or an experienced
                diver seeking new destinations, I hope you'll find my content useful when seeking
                inspiration for your next dive.
              </p>
            </motion.div>

            {/* Profile photo */}
            <motion.div
              className="about-photo-wrap"
              initial={{ opacity: 0, x: 30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.7, delay: 0.1 }}
            >
            </motion.div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default AboutPage;
